export default function BestBuyLogo() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_709_40983)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M152.734 95.3295L97.0494 95.2734L97.132 96.2348L2.8426 194.38L5.62485 316.129L98.3283 411.764L130.023 411.944L498.529 410.284L497.247 93.7951L152.734 95.3295Z"
          fill="#F1E04A"
          stroke="#272727"
          stroke-width="2.791"
          stroke-miterlimit="2.613"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M51.1661 237.574C51.0901 241.367 49.558 244.985 46.8873 247.679C44.2166 250.373 40.612 251.936 36.8201 252.045C28.2101 252.045 21.5201 245.294 21.5201 237.574C21.4852 235.549 21.8561 233.538 22.6109 231.658C23.3658 229.779 24.4893 228.069 25.9153 226.631C27.3412 225.193 29.0407 224.054 30.9136 223.283C32.7865 222.512 34.7948 222.124 36.8201 222.141C44.4731 222.139 51.1661 228.89 51.1661 237.574Z"
          fill="#272727"
          stroke="#272727"
          stroke-width="1.395"
          stroke-miterlimit="2.613"
        />
      </g>
      <defs>
        <clipPath id="clip0_709_40983">
          <rect width="512" height="512" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
